import styled, { css } from 'styled-components';

const inlineMixin = css<{ $inline?: boolean }>`
  ${({ $inline }) => $inline && css`
    display: inline;
    margin: 0;
  `}
`;

const H1 = styled.h1<{$inline?: boolean, $withMargins?: boolean }>`
  margin: 0;
  ${({ $withMargins }) => $withMargins && css`
    margin-bottom: 10px;
  `}
  ${inlineMixin};
  font-size: var(--font-size-h1);
  line-height: var(--line-height-heading);
  font-weight: normal;
  color: var(--color-text-headline);
`;

const H2 = styled.h2<{ $inline?: boolean, $withoutMargins?: boolean}>`
  margin: 0;
  ${({ $withoutMargins }) => !$withoutMargins && css`
    margin-bottom: 10px;
  `}
  ${inlineMixin};
  font-size: var(--font-size-h2);
  line-height: var(--line-height-heading);
  font-weight: normal;
  color: var(--color-text-headline);
`;

const H3 = styled.h3<{ $inline?: boolean}>`
  margin: 0;
  margin-bottom: 10px;
  ${inlineMixin};
  font-size: var(--font-size-default);
  line-height: var(--line-height-heading);
  color: var(--color-text-headline);
`;

const SubHeadline = styled.div`
  margin-top: 3px;
  font-size: var(--font-size-default);
  color: var(--color-text-secondary);
`;

export {
  H1, H2, H3, SubHeadline,
};
